import { createTheme, PaletteColorOptions, Theme } from '@mui/material';

declare module '@mui/material' {
    interface PaletteOptions {
        navTextColor?: PaletteColorOptions;
        // primaryYellow?: PaletteColorOptions;
        primaryDark?: PaletteColorOptions;
        primaryLight?: PaletteColorOptions;
        textGrey?: PaletteColorOptions;
        primaryBlue?: PaletteColorOptions;
        primaryMuted?: PaletteColorOptions;
        primaryYellow?: PaletteColorOptions;
    }

    interface SimplePaletteColorOptions {
        main: string;
        medium?: string;
        iconBlue?: string;
        iconGreen?: string;
        iconPurple?: string;
        iconRed?: string;
        yellow?: string;
    }

    interface PaletteColor {
        main: string;
        medium: string;
        iconBlue: string;
        iconGreen: string;
        iconPurple: string;
        iconRed: string;
    }
}

export const theme: Theme = createTheme({
    palette: {
        primary: {
            main: '#05668D',
            iconBlue: '#4CBFFF',
            iconGreen: '#56E39F',
            iconPurple: '#EF6CE2',
            iconRed: '#EF6F6C',
            light: '#fff',
            yellow: '#FFC24C'
        },
        navTextColor: {
            main: '#808080'
        },
        // primaryYellow: {
        //     main: '#FFC24C'
        // },
        primaryDark: {
            light: '#494949',
            main: '#23282B'
        },
        primaryLight: {
            main: '#fff',
            medium: '#EBF6FF'
        },
        primaryMuted: {
            main: '#8CB9CB'
        },
        textGrey: {
            main: '#E6F0F4'
        },
        primaryBlue: {
            main: '#05668D',
            dark: '#0E3A4B'
        },
        primaryYellow: {
            main: '#FFC24C'
        },
        background: {
            default: '#f2f2f2'
        }
    },
    typography: {
        // fontFamily: 'Outfit',
        fontSize: 16,
        fontWeightRegular: 400
    },
    transitions: {
        duration: {
            shortest: 150,
            shorter: 200,
            short: 250,
            // most basic recommended timing
            standard: 300,
            // this is to be used in complex animations
            complex: 375,
            // recommended when something is entering screen
            enteringScreen: 225,
            // recommended when something is leaving screen
            leavingScreen: 195
        },
        easing: {
            // This is the most common easing curve.
            easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
            // Objects enter the screen at full velocity from off-screen and
            // slowly decelerate to a resting point.
            easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
            // Objects leave the screen at full velocity. They do not decelerate when off-screen.
            easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
            // The sharp curve is used by objects that may return to the screen at any time.
            sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
        }
    }
});
